import gql from 'graphql-tag';
import collegeEventLocationFragment from '../../CollegeEventLocation/graphql/collegeEventLocationFragment';

const query = gql`
  query fetchCollegeEvents($scid: ID!, $fromDate: OrdinalDate!) {
    node(id: $scid) {
      ...on HEAccount {
        id
        collegeEvents(fromDate: $fromDate) {
          edges {
            node {
              id
              version
              name
              timezone
              startTime
              endTime
              eventDateTime
              eventEndDateTime
              institution
              eventDescription
              registrationUrl
              displayIn {
                camino
                naviancestudent
              }
              registrationDeadline
              registrationDeadlineTime
              status
              created
              virtual
              lastModifiedDate
              lastModifiedBy
              wasPublished
              collegeEventLocation {
                ...CollegeEventLocation
              }
            }
          }
        }
      }
    }
  }
  ${collegeEventLocationFragment}
`;

export default query;
